export default __webpack_public_path__ + "static/media/kts_meeting.c8f7744d.png";